import * as React from "react";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { useTheme } from "@mui/material/styles";


interface DatePickerProps {
  label: string;
  value: Dayjs | null; // Date value is either a Dayjs object or null
  onChange: (newValue: Dayjs | null) => void;
}

// export default function CustomTimePicker({label,
//   value,
//   onChange}: DatePickerProps) {
//   const theme = useTheme();
//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <MobileTimePicker
//        value={value}
//        onChange={onChange}
//         defaultValue={dayjs()}
//         sx={{ color: theme.palette.primary.light }}
//       />
//     </LocalizationProvider>
//   );
// }


// interface DatePickerProps {
//   label?: string;
//   value: any;
//   onChange: (value: any) => void;
// }

export default function CustomTimePicker({
  label,
  value,
  onChange,
}: DatePickerProps) {
  const theme = useTheme();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MobileTimePicker
        label={label}
        value={value}
        onChange={onChange}
        ampm={false} // 
        sx={{ color: theme.palette.primary.light }}
      />
    </LocalizationProvider>
  );
}
